import Home from '../pages/Home';
import ErrorPage from '../pages/ErrorPage';
import LoginPage from '../pages/Login';
import MyInfoPage from '../pages/Me';
import APITest from '../pages/apitest';
import Setup from '../pages/Setup';
import LLM from '../pages/LLM';
import AgentRedirect from '../pages/AgentRedirect';
import Documentation from '../pages/Documentation';
import AuthProvider from '../providers/AuthContext';
import Base from '../layouts/Base';
import GirderUpdatesWrapper from '../components/GirderUpdatesWrapper';

import AdminRoutes from './admin';
import AuthTestRoutes from './authtest';
import ManageRoutes from './manage';
import GirderRoutes from './girder';
import ProjectsRoutes from './projects';

import {
   createBrowserRouter
 } from "react-router-dom";
 

const BrowserRouter = createBrowserRouter([{
    element: <AuthProvider/>,
    children:[
        {
            element: <GirderUpdatesWrapper/>,
            children: [
            //Basic routes; use Base and ErrorPage
            {
                path: "/",
                element: <Base />,
                errorElement: <ErrorPage/>, 
                children: [
                    {
                        index:true,
                        element: <Home/>
                    },
                    {
                        path: "setup",
                        element: <Setup />,
                    },
                    {
                        path: "Login",
                        element: <LoginPage />,
                    },
                    {
                        path: "Me",
                        element: <MyInfoPage />,
                    },
                    {
                        path: "apitest",
                        element: <APITest />,
                    },
                    {
                        path: "llm",
                        element: <LLM />,
                    },
                    {
                        path: "agents",
                        element: <AgentRedirect />,
                    },
                    {
                        path: "documentation/*",
                        element: <Documentation />,
                    },
                ]
            },
            AdminRoutes,
            ManageRoutes,
            GirderRoutes,
            ...ProjectsRoutes,
            AuthTestRoutes,
            // {
            //     path:'/view/basic/:id',
            //     element: <Basic />,  
            //     loader: ViewerLoader
            // }
            ]
        }
    ],
}]);

export default BrowserRouter;